import React from "react";

const markets = ["Middle East", "Europe", "Africa", "Southeast Asia", "Other International Markets"];

const GlobalSupply = () => (
  <div>
    <section className="bg-[#004225] text-white grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Global Supply</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Supplying to Buyer Requirements Worldwide</h1>
        <p className="mt-3 max-w-2xl text-white/80">India-based sourcing and export capability serving global buyers across multiple regions. Supply is confirmed per RFQ, subject to specification, quantity and destination.</p>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-10">
      <div>
        <div className="text-[11px] font-eyebrow text-[#B5942D]">Regions</div>
        <h2 className="mt-2 font-display text-3xl text-[#004225]">Regions We Supply To</h2>
        <ul className="mt-4 space-y-2">
          {markets.map((m) => (
            <li key={m} className="text-[14px] text-[#171717]/85 border-b border-[#004225]/10 py-2"><span className="text-[#D4AF37] mr-2">•</span>{m}</li>
          ))}
        </ul>
      </div>
      <div className="rounded-sm overflow-hidden border border-[#004225]/10 bg-[#002B18]">
        <svg viewBox="0 0 800 500" className="w-full h-full">
          <rect width="800" height="500" fill="#003c22" />
          <g fill="#F4F4ED" opacity="0.9">
            <path d="M120,180 q40,-40 90,-20 t120,10 t60,40 t-60,60 t-120,20 t-80,-50z" />
            <path d="M340,220 q60,-50 140,-40 t150,30 t60,50 t-60,80 t-140,40 t-160,-40 t10,-120z" />
            <path d="M170,320 q30,-10 50,10 t40,60 t-50,50 t-60,-40z" />
          </g>
          <g stroke="#D4AF37" strokeWidth="1.4" fill="none" className="route-anim">
            <path d="M470,300 C520,180 620,150 690,120" />
            <path d="M470,300 C560,230 640,240 720,220" />
            <path d="M470,300 C400,260 300,240 200,210" />
            <path d="M470,300 C500,360 520,400 560,430" />
          </g>
          <g fill="#D4AF37">
            <circle cx="470" cy="300" r="5" />
            <circle cx="690" cy="120" r="4" />
            <circle cx="720" cy="220" r="4" />
            <circle cx="200" cy="210" r="4" />
            <circle cx="560" cy="430" r="4" />
          </g>
        </svg>
      </div>
    </section>
  </div>
);

export default GlobalSupply;
